import React, { useEffect, useState } from 'react'
import CustomTitle from '../../components/UI/title/CustomTitle'
import Promocode from './components/Promocode/Promocode'
import Tariffs from './components/Tariffs/Tariffs'
import PageContent from '../../components/PageContent/PageContent';

export default function FinalPlan() {
    const [activePlan, setActivePlan] = useState('1');
    useEffect(() => {
        document.documentElement.style.overflow = 'auto';
    }, [])
    const [planId, setPlanId] = useState(4);

    return (
        <div className="plan page page--without-button">
        
                    <CustomTitle style={{ marginBottom: "24rem" }} title="New promo code applied: <br>up to <span>70%</span> 80% discount!" />
                    <Promocode final={true} />
                    <Tariffs final={true} setActivePlan={setActivePlan} activePlan={activePlan} buttonShow={true} planId={planId} setPlanId={setPlanId} />
       


        </div>
    )
}
